import {css} from '@emotion/react';
import React from 'react';
import Input from "../../../Input";
import {
    columnModalFull,
    columnModalLeft,
    columnModalLeftMult,
    columnModalRight,
    modalSubtitle,
    modalTextDescription,
    multiRowModal, notCentered,
    rowModal,
} from "../../styles";
import {IconBlue} from "../IconBlue";
import {Select} from "../../../Select";
import {options} from './DropdownStateOptions/index';
import {phoneStyle, selectStyle} from "./Styles";
import InputMask from "react-input-mask";
import {phoneCss} from "../ByStateCallsCard/styles";
import DatePicker from "react-datepicker";
import {
    KeyboardDatePicker,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from "@material-ui/core/styles";

import moment, {Moment} from "moment";


export interface SimpleRowEditProps {
    hideEdit?: boolean;
    name: string;
    value?: string;
    placeholder?: string;
    onChange?(name: string, value: string): void;
}

export interface SimpleRowProps {
    label: React.ReactNode;
    value: React.ReactNode;
    variant?: "default" | "select" | "phone" | "date" | "time";
    editProps?: SimpleRowEditProps;
    multiRow?: boolean;
    fullWidth?: boolean;
    titleCentered?: boolean;
}

const timeToMoment = (input: string) => {
    return moment(input.replace(/(( hours, )|( minutes and )|( seconds))/g, ":"),"HH:mm:ss:");
}

const momentToTime = (input: Moment) => {
    const h = input.format('HH');
    const m = input.format('mm');
    const s = input.format('ss');

    return `${h} hours, ${m} minutes and ${s} seconds`
}

const useStyles = makeStyles({
    root: {
        "&": { marginTop: "0 !important", marginBottom: "0 !important", }
        // "&.MuiFormControl-marginNormal": {
        //     marginTop: 0,
        //     marginBottom:0,
        // },
        // "root":{
        //     paddingLeft: "5px",
        //     border: "1px solid #a9a9a9",
        //     borderRadius: "4px !important",
        // },
        // "underline:before":{
        //     borderBottom: "none",
        // },
        // "underline:after":{
        //     borderBottom: "none",
        //     transform: "none",
        //     transition: "none",
        // },
    }
});

const Datepicker: React.FC<Pick<SimpleRowProps,'editProps'>> = ({
    editProps
                    }) => {

    const [DatePickerOpen, setDatePickerOpen] = React.useState(false);
    const classes = useStyles();

    return(
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <Input value={editProps?.value} onClick={() => setDatePickerOpen(true)}></Input>
            <KeyboardDatePicker
                margin="normal"
                id="date-picker-dialog"
                name ={editProps?.name}
                format="yyyy-MM-DD"
                className={classes.root}
                open = {DatePickerOpen}
                onOpen = {() => setDatePickerOpen(true)}
                onClose = {() => setDatePickerOpen(false)}
                TextFieldComponent={() => null}
                value={editProps?.value}
                onChange={date => {
                    editProps?.onChange?.(editProps.name, moment(date).format("yyyy-MM-DD"));
                }
                }
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
            />
        </MuiPickersUtilsProvider>
    )
}

export const SimpleRow: React.FC<SimpleRowProps> = ({
    label,
    value,
    editProps,
    multiRow,
    variant="default",
    fullWidth,
    titleCentered = true
}) => {


    return <div css={multiRow ? multiRowModal :  rowModal}>
        <div css={[multiRow ? columnModalLeftMult : columnModalFull, !titleCentered && notCentered]}>
            <IconBlue style ={{alignSelf:"center"}}/>
            <p css={modalSubtitle}>{label}</p>
        </div>

        <div css={columnModalRight}>
            <p css={modalTextDescription} style={fullWidth ? {width:'100%'} : {} } >

                {variant == "date" ?

                    editProps && !editProps.hideEdit ?

                        <Datepicker
                            editProps={editProps}
                        />

                        // <DatePicker
                        //     name={editProps.name}
                        //     placeholderText={editProps.placeholder}
                        //     value={editProps.value}
                        //     css={phoneStyle}
                        //     onChange={date => {
                        //             if(date instanceof Date) {
                        //                 editProps?.onChange?.(editProps.name, moment(date.getTime()).format("yyyy-MM-DD"));
                        //             }
                        //         }
                        //     }
                        // />
                        : value
                    :

                    variant == "time" ?

                        editProps && !editProps.hideEdit ?

                            <InputMask
                                name={editProps.name}
                                mask = "99 hours, 99 minutes \and 99 seconds"
                                placeholder={editProps.placeholder}
                                value={momentToTime(moment(editProps.value,"HH:mm:ss"))}
                                onChange={event => {
                                    const { name, value } = event.target;
                                    editProps?.onChange?.(name, timeToMoment(value).format("HH:mm:ss"));
                                 }
                                }
                                css={[phoneStyle,css`width:300px; padding-left:5px;`]}
                            />
                            : value
                        :

                    variant == "phone" ?

                     editProps && !editProps.hideEdit ?

                        <InputMask
                            name={editProps.name}
                            mask = "+1 (999) 999-9999"
                            placeholder={editProps.placeholder}
                            value={editProps.value}
                            onChange={event => {
                                const { name, value } = event.target;
                                editProps?.onChange?.(name, value);
                             }
                            }
                            css={phoneStyle}
                        />
                        : value
                    :

                    variant == "select" ?
                    editProps && !editProps.hideEdit ? // CRUD SELECT

                    <Select name={editProps.name} options={options} placeholder={editProps.placeholder} css={selectStyle} variant={"modalish"}
                            onChange={event => {
                                if(event)
                                    editProps?.onChange?.(editProps.name, event.value);

                            }}  value={options.find((x) => x.value === editProps.value || null)}  />
                            : value
                    :

                    editProps && !editProps.hideEdit ?
                    <Input name={editProps.name}  style={fullWidth ? {width:'100%'} : {} } placeholder={editProps.placeholder} onChange={event => {
                        const { name, value } = event.target;
                        editProps?.onChange?.(name, value);
                    }} overrideCss={multiRow ? css `width: 200px;` : css` width: 300px;`} value={editProps.value} />
                    : value}
            </p>
        </div>

    </div>
};